import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { B03aCardAddPage } from '../b03a-card-add/b03a-card-add';
import { B03bCardInfoPage } from '../b03b-card-info/b03b-card-info';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B11AlertEventPage } from '../b11-alert-event/b11-alert-event';
/**
 * Generated class for the B03CardManagementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface cardInfo{
  CARD_ID: number;
  CARD_NO: string;
  CAR_PLATE: string; 
  CREDIT_LIMIT: string; 
  BALANCE: string; 
  CARD_ACTIVE: string;  
  CORP_ID: number;
  CORP_NAME: string;
}

interface corpInfo{
  CORP_ID: number;
  CORP_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b03-card-management',
  templateUrl: 'b03-card-management.html',
})
export class B03CardManagementPage {

  loading: any;
  Status: any;
  cardArr: cardInfo[] = [];
  cardItems: cardInfo[] = [];
  corpArr: corpInfo[] = [];
  corpItems: corpInfo[] = [];
  public errorMessage: any = "";
  public searchMessage:any ="";
  corporate: any = "";
  cardNumber:any = "";
  GRP_ID: any;
  CORP_ID: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, private toastCtrl: ToastController, 
              public loadingCtrl: LoadingController) {

    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.CORP_ID = sessionStorage.getItem('usercorpid');

    let sortby= "No";
    let sorttype= "No";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];

    if(this.GRP_ID=="1") {            //system admin
      temp_tbl = ["All"];
      temp_column = ["All"];
      temp_value = ["All"];
    }
    else if ((this.GRP_ID == "6") || (this.GRP_ID == "7")) {      //corporate admin/ manager
      temp_tbl = ["CARD"]; 
      temp_column = ["CORP_ID"];
      temp_value = [this.CORP_ID];
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["CORP_ID"];
    let fktbl = ["CORPORATE"];
    let fkkey = ["CORP_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.cardArr = Records;
        this.cardItems = this.cardArr;
        
        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];
      
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");


        this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
          this.loading.dismiss();
          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.corpArr = Records;
            this.corpItems = this.corpArr;
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else {
        this.loading.dismiss();
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B03CardManagementPage');
  }

  goToAddCard(){
    this.navCtrl.push(B03aCardAddPage);
  }

  editCard(ID){
    this.navCtrl.push(B03bCardInfoPage, {paramID: ID});               //card ID
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  clearItem(){
    this.cardNumber = "";
    this.corporate = "";
  }

  searchItem(){
    this.searchMessage="";
    this.errorMessage="";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];
    this.cardItems = [];

    let sortby= "No";
    let sorttype= "No";

    if (this.cardNumber!=""){

      if(this.GRP_ID=="1" || this.GRP_ID=="2" || this.GRP_ID=="3" || this.GRP_ID=="4" || this.GRP_ID=="9") {            //system admin
        temp_tbl = ["CARD"];
        temp_column = ["CARD_NO"];
        temp_value = [this.cardNumber];
      }
      else if ((this.GRP_ID == "6") || (this.GRP_ID == "7")) {      //corporate admin/ manager
        temp_tbl = ["CARD", "CARD"]; 
        temp_column = ["CARD_NO", "CORP_ID"];
        temp_value = [this.cardNumber, this.CORP_ID];
      }
      this.corporate="";
    }
    else if (this.corporate!=""){
      temp_tbl = ["CARD"];
      temp_column = ["CORP_ID"];
      temp_value = [this.corporate];
      this.cardNumber="";
    }
    else {

      if(this.GRP_ID=="1" || this.GRP_ID=="2" || this.GRP_ID=="3" || this.GRP_ID=="4" || this.GRP_ID=="9") {            //system admin
        temp_tbl = ["All"];
        temp_column = ["All"];
        temp_value = ["All"];
      }
      else if ((this.GRP_ID == "6") || (this.GRP_ID == "7")) {      //corporate admin/ manager
        temp_tbl = ["CARD"]; 
        temp_column = ["CORP_ID"];
        temp_value = [this.CORP_ID];
      }
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["CORP_ID"];
    let fktbl = ["CORPORATE"];
    let fkkey = ["CORP_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.cardArr = Records;
        this.cardItems = this.cardArr;
        
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }
  goToAlert()
  {
    this.navCtrl.push(B11AlertEventPage, {paramID: this.CORP_ID});               //card ID
  }
}



// WEBPACK FOOTER //
// ./src/pages/b03-card-management/b03-card-management.ts